import { lazy, Suspense } from "react";
import Loader from "../custom/loader/main";

const ResetPassword = () => {

    const Main = lazy(() => import('../components/resetPassword/main'))
return(
    <Suspense fallback={<Loader/>}>
        <Main/>
    </Suspense>

)
}

export default ResetPassword;